const generateAccordion = () => {
  const collapsePlusTemplate = `<a class="accordion-action">+</a>`

  const accordions = document.querySelectorAll(".accordion")
  accordions.forEach((acc) => {
    // hide all accordion
    acc.classList.add("closed")
    acc
      .querySelector(".accordion-header")
      .insertAdjacentHTML("beforeend", collapsePlusTemplate)
  })
  const actions = document.querySelectorAll(".accordion-header")
  actions.forEach((acc) => {
    acc.addEventListener("click", (e) => {
      acc.parentElement.classList.toggle("closed")
      acc.parentElement.classList.toggle("open")
      if (!Array.from(acc.parentElement.classList).includes("closed")) {
        acc.querySelector(".accordion-action").innerHTML = "-"
      } else {
        acc.querySelector(".accordion-action").innerHTML = "+"
      }
    })
  })
}

document.addEventListener("DOMContentLoaded", function (event) {
  generateAccordion()
})
